import { render } from "./ApplyJobVacancy.vue?vue&type=template&id=885ed3b8&scoped=true"
import script from "./ApplyJobVacancy.vue?vue&type=script&lang=js"
export * from "./ApplyJobVacancy.vue?vue&type=script&lang=js"

import "./public-job-vacancy.scss?vue&type=style&index=0&id=885ed3b8&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885ed3b8"]])

export default __exports__